import { safeGetItem, safeRemoveItem, safeSetItem, type StorageArea } from "@/utils/safeStorage";

const SUBSCRIBED_EMAIL_KEY = "truevined_mailing_email";
const UNLOCK_TOKEN_KEY = "truevined_mailing_unlock_token";
const DISMISSED_AT_KEY = "truevined_mailing_popup_dismissed_at";
const SHOWN_SESSION_KEY = "truevined_mailing_popup_shown";

const local = (): StorageArea => "local";
const session = (): StorageArea => "session";

const read = (area: StorageArea, key: string) => safeGetItem(key, area);

const write = (area: StorageArea, key: string, value: string) => {
  safeSetItem(key, value, area);
};

export const MAILING_EMAIL_CHANGED_EVENT = "truevined:mailing:email";

const notifyEmailChanged = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(MAILING_EMAIL_CHANGED_EVENT));
};

export function getSubscribedEmail(): string | null {
  return read(local(), SUBSCRIBED_EMAIL_KEY);
}

export function rememberSubscribedEmail(email: string) {
  write(local(), SUBSCRIBED_EMAIL_KEY, email.trim().toLowerCase());
  notifyEmailChanged();
}

export function forgetSubscribedEmail() {
  safeRemoveItem(SUBSCRIBED_EMAIL_KEY, local());
  safeRemoveItem(UNLOCK_TOKEN_KEY, local());
  notifyEmailChanged();
}

export function getUnlockToken(): string | null {
  return read(local(), UNLOCK_TOKEN_KEY);
}

export function rememberUnlockToken(token: string) {
  write(local(), UNLOCK_TOKEN_KEY, token.trim());
  notifyEmailChanged();
}

export function getPopupDismissedAt(): number {
  return Number(read(local(), DISMISSED_AT_KEY) || 0);
}

export function rememberPopupDismissed() {
  write(local(), DISMISSED_AT_KEY, String(Date.now()));
}

export function wasPopupShownThisSession(): boolean {
  return read(session(), SHOWN_SESSION_KEY) === "1";
}

export function rememberPopupShownThisSession() {
  write(session(), SHOWN_SESSION_KEY, "1");
}

export const MAILING_POPUP_OPEN_EVENT = "truevined:mailing:open";

export function openMailingPopup() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(MAILING_POPUP_OPEN_EVENT));
}

const GATE_DISMISSED_KEY = "truevined_artist_gate_dismissed";

const readDismissedGates = (): string[] => {
  const raw = read(session(), GATE_DISMISSED_KEY);
  return raw ? raw.split(",").filter(Boolean) : [];
};

export function wasArtistGateDismissed(slug: string): boolean {
  return readDismissedGates().includes(slug.toLowerCase());
}

export function rememberArtistGateDismissed(slug: string) {
  const key = slug.toLowerCase();
  const current = readDismissedGates();
  if (current.includes(key)) return;
  write(session(), GATE_DISMISSED_KEY, [...current, key].slice(-30).join(","));
}

export function forgetArtistGateDismissed(slug: string) {
  const key = slug.toLowerCase();
  const next = readDismissedGates().filter((value) => value !== key);
  write(session(), GATE_DISMISSED_KEY, next.join(","));
}
